import createLogger from 'vuex/dist/logger';
import Vue from 'vue';
import Vuex from 'vuex';
import {getField, updateField} from 'vuex-map-fields';
import user from './store/modules/user';
import account from './store/modules/account';
import stripe from './store/modules/stripe';
import test from './store/modules/test';
import amacro from './store/modules/amacro';
import result from './store/modules/result';
import testSuite from './store/modules/testSuite';
import dashboard from './store/modules/dashboard';
import system from './store/modules/system';
import git from './store/modules/git';
import loadTest from './store/modules/loadTest';

Vue.use(Vuex);
const debug = process.env.NODE_ENV !== 'production';
export default new Vuex.Store({
  modules: {
    user,
    account,
    stripe,
    test,
    amacro,
    result,
    testSuite,
    dashboard,
    system,
    git,
    loadTest
  },
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  getters: {
    // Add the `getField` getter to the
    // `getters` of your Vuex store instance.
    getField
  },
  mutations: {
    // Add the `updateField` mutation to the
    // `mutations` of your Vuex store instance.
    updateField
  }
});
